import { SITE } from "@/config/site";

// Minimal, dependency-free renderer for admin-authored article content.
// Supports paragraphs, "## " headings and "- " bullet lists.
const ArticleBody = ({ content, testid = "article-body" }) => {
  const blocks = content.split(/\n\s*\n/);
  return (
    <div className="space-y-6" data-testid={testid}>
      {blocks.map((block, i) => {
        const trimmed = block.trim();
        if (trimmed.startsWith("## ")) {
          return (
            <h2 key={i} className="pt-4 font-display text-xl font-bold text-brand-snow sm:text-2xl">
              {trimmed.slice(3)}
            </h2>
          );
        }
        if (trimmed.startsWith("- ")) {
          return (
            <ul key={i} className="space-y-3">
              {trimmed.split("\n").map((line, j) => (
                <li key={j} className="flex items-start gap-3 text-base leading-relaxed text-brand-mist">
                  <span aria-hidden="true" className="mt-2.5 h-1.5 w-1.5 shrink-0 rounded-full bg-brand-emerald" />
                  {line.replace(/^-\s*/, "")}
                </li>
              ))}
            </ul>
          );
        }
        return (
          <p key={i} className="text-base leading-relaxed text-brand-mist sm:text-lg">
            {trimmed}
          </p>
        );
      })}
    </div>
  );
};

export const formatPostDate = (iso) =>
  iso
    ? new Date(iso).toLocaleDateString("en-AU", { day: "numeric", month: "long", year: "numeric", timeZone: "UTC" })
    : "";

export const postUrl = (slug) => `${SITE.domain}/resources/${slug}`;

export default ArticleBody;
